import { Injectable } from '@angular/core';

import { ErrorMessageResponse } from '@app/core/models/data-response';
import { DataTaskService } from '@app/core/services/data-task.service';

@Injectable({
    providedIn: 'root',
})
export class ChoicePossRulesService {
    constructor(private dataTask: DataTaskService) {}

    public async getRule(params: ChoicePossRuleParams): Promise<ChoicePossRuleGet> {
        return ((await this.dataTask.Post(1176, params)) as ChoicePossRuleGet[])[0];
    }

    public async saveRule(page: ChoicePossRuleGet): Promise<ErrorMessageResponse> {
        return ((await this.dataTask.Post(1177, page)) as ErrorMessageResponse[])[0];
    }

    public deleteRule(page: ChoicePossRuleGet): Promise<void> {
        return this.dataTask.Post(1186, page);
    }

    public async getRulesPage(params: ChoicePossRulesPageParams): Promise<ChoicePossRulesGet> {
        return ((await this.dataTask.Post(1158, params)) as ChoicePossRulesGet[])[0];
    }

    public async getRunPage(): Promise<ChoicePossRulesRunGet> {
        return ((await this.dataTask.Post(1193, {})) as ChoicePossRulesRunGet[])[0];
    }

    public async changeModelId(params: ChoicePossRulesFilter): Promise<NumberOfProductsResponse> {
        return ((await this.dataTask.Post(1190, params)) as NumberOfProductsResponse[])[0];
    }

    public async changeChoiceProductId(params: ChoiceProductParams): Promise<NumberOfFurnitureFabricsResponse> {
        return ((await this.dataTask.Post(1185, params)) as NumberOfFurnitureFabricsResponse[])[0];
    }

    public listFurnitureFabrics(params: FurnitureFabricParams): Promise<FurnitureFabricItem[]> {
        return this.dataTask.Post(1173, params);
    }

    public listChosenProducts(params: ChoicePossRulesFilter): Promise<ChosenProductItem[]> {
        return this.dataTask.Post(1175, params);
    }

    public listRules(params: ChoicePossRulesGet): Promise<ChoicePossRulesItem[]> {
        return this.dataTask.Post(1178, params);
    }

    public listProductNames(params: ChoicePossRulesFilter): Promise<ProductNameItem[]> {
        return this.dataTask.Post(1191, params);
    }

    public async getProductKeyno(params: ProductIdParams): Promise<ProductKeynoResponse> {
        return ((await this.dataTask.Post(1192, params)) as ProductKeynoResponse[])[0];
    }

    public listProductChoices(params: AddAllParams = {}): Promise<ProductChoiceItem[]> {
        return this.dataTask.Post(1159, params);
    }

    public listModels(params: ModelsParams): Promise<ModelItem[]> {
        return this.dataTask.Post(1174, params);
    }

    public listCounts(params: ChoicePossRulesRunGet): Promise<ChoicePossRulesItem[]> {
        return this.dataTask.Post(1194, params);
    }

    public listProducts(params: ChoicePossRulesRunGet): Promise<ChoicePossRulesItem[]> {
        return this.dataTask.Post(1195, params);
    }

    public executeRule(params: ChoicePossRulesRunGet & ProductIdParams): Promise<void> {
        return this.dataTask.Post(1196, params);
    }
}

export interface ChoicePossRuleParams {
    choicepossrule_keyno: string | number;
}

export interface ChoicePossRulesPageParams {
    argtype: string;
    argvalue: string;
}

export interface ChoicePossRuleGet extends ChoicePossRulesFilter {
    choicepossrule_keyno: string | number;
    choosed_prod_id: string;
    isvalid: string | boolean;
    runorder: string | number;
}

export interface ChoicePossRulesGet extends ChoicePossRulesFilter {
    prod_id_choosed: string;
}

export interface ChoicePossRulesRunGet {
    choice_prod_id: string;
    model_id: string;
}

export interface ChoicePossRulesFilter {
    choice_prod_id: string;
    model_id: string;
    prod_id: string;
    prod_name: string;
    furniturefabrics_id: string;
    nbr_of_furniturefabrics: number;
    nbr_of_products: number;
}

export interface ProductChoiceItem {
    prod_id: string;
    prod_name: string;
}

export interface ModelItem {
    model_id: string;
    model_name: string;
}

export interface ProductNameItem {
    prod_id: string;
    prod_name: string;
}

export interface FurnitureFabricItem {
    furniturefabrics_id: string;
    furniturefabrics_name: string;
}

export interface ChosenProductItem {
    prod_id_choosed: string;
    prod_name_choosed: string;
}

export interface ChoicePossRulesItem {
    item_id: string;
    item_name: string;
    badgeinfo?: string;
}

export interface NumberOfProductsResponse {
    nbr_of_products: number;
}

export interface NumberOfFurnitureFabricsResponse {
    nbr_of_furniturefabrics: number;
}

export interface ProductKeynoResponse {
    prod_keyno: string;
}

export interface ProductIdParams {
    prod_id: string;
}

export interface ChoiceProductParams {
    choice_prod_id: string;
}

export interface FurnitureFabricParams extends ChoiceProductParams, AddAllParams {}

export interface AddAllParams {
    add_all?: '1';
}

export interface ModelsParams extends AddAllParams {
    show_inactive: '0';
}
